export const BOOKINGS_APP_DEF_ID = '13d21c63-b5ec-5912-8397-c3a5ddb27a97';
export const SCHEDULING_FORM_FIELD_APP_DEF_ID =
  '3e4e322b-6d9b-4da0-9f53-e22c4a44a49e';
